export const types = {
  GET_HORIZONTAL_ADDRESSES: "ADDRESSES/GET_HORIZONTAL_ADDRESSES",
  SET_HORIZONTAL_ADDRESSES: "ADDRESSES/SET_HORIZONTAL_ADDRESSES",
  GET_VERTICAL_ADDRESSES: "ADDRESSES/GET_VERTICAL_ADDRESSES",
  SET_VERTICAL_ADDRESSES: "ADDRESSES/SET_VERTICAL_ADDRESSES",
};

export const initialState = {
  horizontalAddresses: null,
  horizontalAddressesLoading: false,
  verticalAddresses: null,
  verticalAddressesLoading: false,
};

export const actions = {
  getHorizontalAddresses: ({address}) => ({
    type: types.GET_HORIZONTAL_ADDRESSES,
    address,
  }),
  setHorizontalAddresses: (data) => ({
    type: types.SET_HORIZONTAL_ADDRESSES,
    payload: data,
  }),
  getVerticalAddresses: ({id, address}) => ({
    type: types.GET_VERTICAL_ADDRESSES,
    id,
    address,
  }),
  setVerticalAddresses: (data) => ({
    type: types.SET_VERTICAL_ADDRESSES,
    payload: data,
  }),
};

function reducer(state = { ...initialState }, { type, payload }) {
  switch (type) {
    case types.GET_HORIZONTAL_ADDRESSES:
      return {
        ...state,
        horizontalAddresses: null,
        horizontalAddressesLoading: true,
      };
    case types.SET_HORIZONTAL_ADDRESSES:
      return {
        ...state,
        horizontalAddresses: payload,
        horizontalAddressesLoading: false,
      };
    case types.GET_VERTICAL_ADDRESSES:
      return {
        ...state,
        verticalAddresses: null,
        verticalAddressesLoading: true,
      };
    case types.SET_VERTICAL_ADDRESSES:
      return {
        ...state,
        verticalAddresses: payload,
        verticalAddressesLoading: false,
      };
    default:
      return state;
  }
};

export default reducer;
